(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    function updateArrows(sectionEl) {
      var track = sectionEl.querySelector('.events-grid');
      var arrows = sectionEl.querySelectorAll('.events-grid-slider-arrow');
      if (!track || arrows.length === 0) return;

      var visibleCard = Array.prototype.slice.call(track.querySelectorAll('.event-card'))
        .find(function (card) { return card.style.display !== 'none'; });
      var image = visibleCard ? visibleCard.querySelector('.event-card__image img') : null;

      if (image) {
        var setTop = function () {
          var halfHeight = image.offsetHeight / 2;
          arrows.forEach(function (arrow) {
            arrow.style.top = halfHeight + 'px';
            arrow.style.transform = 'translateY(-50%)';
          });
        };
        if (image.complete) {
          setTop();
        } else {
          image.addEventListener('load', setTop);
        }
      }

      var canScroll = track.scrollWidth > track.clientWidth + 4;
      arrows.forEach(function (arrow) {
        arrow.classList.toggle('is-hidden', !canScroll);
      });
    }

    var allSections = document.querySelectorAll('.events-grid-section');

    allSections.forEach(function (sectionEl) {
      updateArrows(sectionEl);
    });

    window.addEventListener('resize', function () {
      allSections.forEach(function (sectionEl) {
        updateArrows(sectionEl);
      });
    });

    document.querySelectorAll('.events-grid-filter__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = this.dataset.filter;
        var section = this.closest('.events-grid-section');
        var buttons = section.querySelectorAll('.events-grid-filter__btn');
        var cards = section.querySelectorAll('.event-card');

        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        cards.forEach(function (card) {
          var cardLocation = card.dataset.location.toLowerCase();
          var filterLower = filter.toLowerCase();
          if (filter === 'all' || cardLocation.indexOf(filterLower) !== -1) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });

        updateArrows(section);
      });
    });

    document.querySelectorAll('.events-grid-slider-arrow').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var section = this.closest('.events-grid-section');
        var track = section.querySelector('.events-grid');
        var firstCard = track.querySelector('.event-card');
        var scrollAmount = firstCard ? firstCard.getBoundingClientRect().width + 24 : 300;

        if (this.dataset.direction === 'next') {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
      });
    });

    document.querySelectorAll('.event-card__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var targetId = this.dataset.target;
        var body = document.getElementById(targetId);
        if (!body) return;

        var isTruncated = body.classList.toggle('is-truncated');
        this.textContent = isTruncated ? 'See more' : 'See less';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('header.header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
